import React from 'react';

const IconFullScreen = props => (<svg viewBox="0 0 16 16" width="16px" height="16px" {...props}>
  <path d="M2.28571429,10.2857143 L0,10.2857143 L0,16 L5.71428571,16 L5.71428571,13.7142857 L2.28571429,13.7142857 L2.28571429,10.2857143 Z M0,5.71428571 L2.28571429,5.71428571 L2.28571429,2.28571429 L5.71428571,2.28571429 L5.71428571,0 L0,0 L0,5.71428571 Z M13.7142857,13.7142857 L10.2857143,13.7142857 L10.2857143,16 L16,16 L16,10.2857143 L13.7142857,10.2857143 L13.7142857,13.7142857 Z M10.2857143,0 L10.2857143,2.28571429 L13.7142857,2.28571429 L13.7142857,5.71428571 L16,5.71428571 L16,0 L10.2857143,0 Z" />
</svg>);

export default IconFullScreen;
